import type { Condition } from 'types/helios/templateForms';
import type { ConditionType, HeliosConditionsState } from '..';

export const addConditionToIndex = (
  state: HeliosConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      index: number;
      condition: Condition;
    };
  }
) => {
  if (state[payload.type]?.conditions) {
    state[payload.type]!.conditions!.splice(payload.index + 1, 0, payload.condition);
  }
};
